import "./Sidebar.scss";
import { NavLink as RouterLink } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { icons, toolsicon } from "../../assets/images/icons/icons";
import axios from "axios";
import usePermission from "../../hooks/usePermission";
import PermissionFunctions from "../../assets/functions/PermissionFunctions";
import MainServices from "../../services/MainServices";
import useTheme from "../../hooks/useTheme";
import useAuth from "../../hooks/useAuth";
import LimsLightThemeLogo from "../../assets/images/icons/BRAND_LOGOS/LimsLightThemeLogo.png";
import LimsDarkThemeLogo from "../../assets/images/icons/BRAND_LOGOS/LimsDarkThemeLogo.png";
import LimsLightThemeLogoWithText from "../../assets/images/icons/BRAND_LOGOS/LimsLightThemeLogoWithText.png";
import LimsDarkThemeLogoWithText from "../../assets/images/icons/BRAND_LOGOS/LimsDarkThemeLogoWithText.png";

export default function Sidebar({ setSidebarToggle }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [menuToggle, setMenuToggle] = useState({});
  const [menus, setMenus] = useState([]);
  const { grantPermission } = PermissionFunctions();
  const [applications, setApplications] = useState([]);
  const { getToolsAccess } = MainServices();
  const [menuToggleTool, setMenuToggleTool] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { theme } = useTheme();
  const {
    user: { role },
  } = useAuth();

  const handleMenuToggleTool = () => {
    setMenuToggleTool(!menuToggleTool);
  };

  useEffect(() => {
    axios
      .get("menu.json")
      .then(function (res) {
        if (res?.data) {
          let resData = res.data;
          resData = resData.menus ? resData.menus : [];
          setMenus(resData);
        }
      })
      .catch(function (res) {
        console.log(res);
        console.log("An error occurred menu json");
      });
  }, []);

  useEffect(() => {
    getToolMasterByStatus();
  }, []);

  useEffect(() => {
    if (menus.length === 0) return;
    setMenuToggle((prev) => {
      const next = { ...prev };
      menus.forEach((each) => {
        if (each.children?.length > 0) {
          if (pathname === each.link || pathname.startsWith(each.link + "/")) {
            next[each.icon] = true;
          }
        }
      });
      return next;
    });
  }, [menus, pathname]);

  const onLogout = () => {
    localStorage.clear();
    navigate("/login");
    window.location.reload();
  };

  const toggle = (type) => {
    if (type === "usermanagementicon") {
      navigate({ pathname: "masters/branches" });
    }
    if (type === "trainingmanagementicon") {
      navigate({ pathname: "documents/registration" });
    }
    setMenuToggle((previousToggle) => ({
      ...previousToggle,
      [type]: !previousToggle[type],
    }));
  };

  const getToolMasterByStatus = async () => {
    const details = {
      pageSize: 20,
      pageNumber: 1,
    };
    await axios
      .all([getToolsAccess(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let location = resData.data ? resData.data : [];
            location = location.map((_) => ({ ..._ }));
            setApplications(location);
          }
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in getting Location");
      });
  };

  return (
    <div className="sidebar-main">
      <div className="nk-sidebar is-light" data-content="sidebarMenu">
        <div className="nk-sidebar-element nk-sidebar-head">
          <div className="nk-sidebar-brand himsidebar-logo">
            <div className="himsidebar-logo-main">
              <img
                src={theme === "dark" ? LimsDarkThemeLogo : LimsLightThemeLogo}
                alt="Lims Pulse"
                className={`sidebar-brand-logo sidebar-brand-logo--${theme}`}
              />
            </div>
          </div>
        </div>
        <hr className="sidebar-divider mt-0" />
        <div className="nk-sidebar-element">
          <div className="nk-sidebar-content">
            <SimpleBar className="nk-sidebar-menu" autoHide={false}>
              <ul className="nk-menu sidebar-option-menu-main">
                {menus &&
                  menus.length > 0 &&
                  menus.map((each) => {
                    if (each.label === "Tasks" && role !== "admin") {
                      return null;
                    }

                    let isChildren = each.children && each.children.length > 0;
                    return (
                      grantPermission(each.required_permission) && (
                        <li
                          className={`nk-menu-item ${
                            isChildren ? "has-sub " : ""
                          }${
                            isChildren && !menuToggle[each.icon]
                              ? "menu-sub-collapse "
                              : ""
                          }${pathname.indexOf(each.link) > -1 ? "active" : ""}`}
                        >
                          {each.children && each.children.length > 0 ? (
                            <>
                              <span
                                className="nk-menu-link nk-menu-toggle span-toggle"
                                onClick={() => toggle(each.icon)}
                              >
                                <span className="nk-menu-icon">
                                  {icons[each.icon]}
                                </span>
                                <span className="nk-menu-text">
                                  {each.label}
                                </span>
                              </span>

                              <ul
                                className="nk-menu-sub sidebar-child-menu"
                                data-menu-label={each.label}
                                style={{
                                  display: menuToggle[each.icon]
                                    ? "block"
                                    : "none",
                                }}
                              >
                                {each.children.map((_) => {
                                  return (
                                    grantPermission(_.required_permission) && (
                                      <li
                                        className={`nk-menu-item ${
                                          pathname === each.link + _.link
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        <RouterLink
                                          to={{
                                            pathname: each.link + _.link,
                                          }}
                                          className="nk-menu-link"
                                        >
                                          <span className="nk-menu-text">
                                            {_.label}
                                          </span>
                                        </RouterLink>
                                      </li>
                                    )
                                  );
                                })}
                              </ul>
                            </>
                          ) : (
                            <RouterLink
                              to={each.link}
                              className={"nk-menu-link"}
                              onClick={() => setMenuToggle({})}
                            >
                              <span className="nk-menu-icon">
                                {icons[each.icon]}
                              </span>
                              <span className="nk-menu-text">{each.label}</span>
                            </RouterLink>
                          )}
                        </li>
                      )
                    );
                  })}
                <li
                  className={`nk-menu-item dropdownTool has-sub ${
                    menuToggleTool ? "active" : "menu-sub-collapse"
                  }`}
                >
                  <button
                    type="button"
                    onClick={handleMenuToggleTool}
                    className={`nk-menu-link nk-menu-toggle button-tool ${
                      menuToggleTool ? "open" : "closed"
                    }`}
                  >
                    <span className="nk-menu-icon toolbutton-icon">
                      {toolsicon}
                    </span>
                    <span className="nk-menu-text toolbutton-text">Tools</span>
                  </button>
                  {menuToggleTool && (
                    <ul
                      className="nk-menu-sub tools-submenu sidebar-child-menu"
                      data-menu-label="Tools"
                    >
                      {applications &&
                        applications.length > 0 &&
                        applications.map(
                          (site) =>
                            site.name !== "auth" && (
                              <li key={site.name} className="nk-menu-item nk-menu-linkss">
                                {site.siteUrl ? (
                                  <a
                                    href={site.siteUrl}
                                    className="nk-menu-link side-menu_links"
                                    onClick={() => setMenuToggle(false)}
                                  >
                                    <span className="nk-menu-text">
                                      {site.name === "auth"
                                        ? "Authentication"
                                        : site.label}
                                    </span>
                                  </a>
                                ) : (
                                  <button
                                    type="button"
                                    className="nk-menu-link side-menu_links"
                                    onClick={() => setMenuToggle(false)}
                                  >
                                    <span className="nk-menu-text">
                                      {site.name === "auth"
                                        ? "Authentication"
                                        : site.label}
                                    </span>
                                  </button>
                                )}
                              </li>
                            )
                        )}
                    </ul>
                  )}
                </li>
                <hr className="sidebar-divider" />
                <div className="sidebar-footer-brand">
                  <img
                    src={theme === "dark" ? LimsDarkThemeLogoWithText : LimsLightThemeLogoWithText}
                    alt="Lims Pulse"
                    className="sidebar-footer-brand-image"
                  />
                </div>
              </ul>
            </SimpleBar>
          </div>
        </div>
      </div>
    </div>
  );
}
